module.exports = __webpack_public_path__ + "img/armada-kapal-chevron.22896c4f.svg";